import { useRecordContext } from 'react-admin';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum } from '@/types/turn-enums';
import { CheckRecordActiveSwitchProps } from './types';
import { TYPE_TO_TARGET } from './constants';

const useController = ({ type }: CheckRecordActiveSwitchProps) => {
  const record = useRecordContext();
  const { runRequest } = useRunRequest();

  const toggleActive = async () =>
    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: record.id,
        target: TYPE_TO_TARGET[type],
      },
      mode: 'notify',
      // useResponseDialog: true,
    });

  return {
    isActive: record.active,
    toggleActive,
  };
};

export default useController;
